/*eslint-disable */
export let polygonHandler = {
    config: {
        map: {
          domID: "map",
          zoom: 4,
          center: { lat: -26.853387500000004, lng: 133.27515449999999 },
          styles: [
            {
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#f5f5f5"
                }
              ]
            },
            {
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#616161"
                }
              ]
            },
            {
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#f5f5f5"
                }
              ]
            },
            {
              "featureType": "administrative.land_parcel",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#bdbdbd"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#eeeeee"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#e5e5e5"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#ffffff"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#dadada"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#616161"
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            },
            {
              "featureType": "transit.line",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#e5e5e5"
                }
              ]
            },
            {
              "featureType": "transit.station",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#eeeeee"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#c9c9c9"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            }
          ],
        },
        polygon: {
          lightStrokeColor: "#999999",
          lightColor: "#AABB99",
          transparentLightStrokeOpacity: "0.5",
          transparentLightFillOpacity: "0.375",
          strokeColor: "#333333",
          strokeWeight: 0.05,
          fillColor: "#336699",
          strokeOpacity: "0.2",
          fillOpacity: "0.85",
          transparentStrokeOpacity: "0.05",
          transparentFillOpacity: "0.25",
          colorZones: ["#1775BB", "#F88B52", "#FBDD03", "#FDC56E", "#FEFAD7", "#D2E289", "#7DCDE8", "#1775BB"] // color zone by index + 1. Example: cz3 => (colorZones[2]) = "#d9ead3"
        },
        debug: {
          enabled: false
        }
    },
    util: {
      getFieldByID: function(data, field, valueToBeFind) {
        data.forEach(element => {
          if(element[field]==valueToBeFind){
            return element[field];
          }
        });
        return null;
      }
    },
    debug: {
      levels: {
        INFO: "INFO",
        WARNING: "WARNING",
        ERROR: "ERROR"
      },
      print: function(level, ...msg){
        if (polygonHandler.config.debug.enabled){
          switch (level) {
            case polygonHandler.debug.levels.WARNING:
              console.warn(msg);  
              break;
            case polygonHandler.debug.levels.ERROR:
              console.error(msg);  
              break;
            default:
              console.log(msg);  
              break;
          }
        }
      },
    },
    loader: {
      config: {
        loaderDomID: 'loader',
        filePath: '../data/',
        files: ['cz1.js', 'cz2.js', 'cz3.js', 'cz4.js', 'cz5.js', 'cz6.js', 'cz7.js']
      },
      promises: [],
      arrays: [],
      // loaderDiv: document.getElementById(polygonHandler.loader.config.loaderDomID),
      loaderDiv: document.getElementById("newloader"),
      handleGetActivePoligons:null,
      init: function() {
       
        polygonHandler.loader.loaderDiv = document.getElementById("newloader");

        polygonHandler.debug.print(polygonHandler.debug.levels.INFO, `Trying to load ${polygonHandler.loader.config.files.length} data files...`);

        let counter = 1;
        polygonHandler.loader.promises = [];
        polygonHandler.loader.arrays = [];
        //--polygonHandler.loader.loaderDiv.classList.remove('hide');
        polygonHandler.loader.loaderDiv.classList.add('newloader');
        //-loading
        /*if(document.getElementById("searchGeoAddress") !== null){
          document.getElementById("dvLoadingSearchGeoAddress").style.display = 'block';
          document.getElementById("searchGeoAddress").style.display = 'none';
        }*/
        //-
        polygonHandler.loader.config.files.forEach(fileName => {

          let promise = polygonHandler.loader.loadFile(fileName);
          
          polygonHandler.debug.print(polygonHandler.debug.levels.INFO, `Loading ${counter}/${polygonHandler.loader.config.files.length} file...`, promise);

          polygonHandler.loader.promises.push(promise);

          polygonHandler.debug.print(polygonHandler.debug.levels.INFO, `${counter}/${polygonHandler.loader.config.files.length} file loaded`);
          counter++;
        });

        Promise.all(polygonHandler.loader.promises)
        .then(results => {            
            polygonHandler.loader.arrays = results.flat();
            polygonHandler.data.polygonList = polygonHandler.loader.arrays;
            polygonHandler.debug.print(polygonHandler.debug.levels.INFO, "Arrays joined", polygonHandler.loader.arrays);
            polygonHandler.map.methods.showPolygons();
            
            //--polygonHandler.loader.loaderDiv.classList.add('hide');
            polygonHandler.loader.loaderDiv.classList.remove('newloader');
            //-loading
            if(document.getElementById("searchGeoAddress") !== null){
              document.getElementById("dvLoadingSearchGeoAddress").style.display = 'none';
              document.getElementById("searchGeoAddress").style.display = 'block';
            }
            //-
        })
        .catch(error => {
          polygonHandler.debug.print(polygonHandler.debug.levels.ERROR, "Error on loading files", error);
        });
      },
      loadFile: function(fileName){
        return fetch(`${polygonHandler.loader.config.filePath}${fileName}`)
        .then(response => response.text())
        .then(data => {
          return eval(data);          
        })
        .catch(error => polygonHandler.debug.print(polygonHandler.debug.levels.ERROR, "Error on loading file", error));
      },     
    },
    // Used to define polygons coordinates and store them on polygons array once created
    data: {
        polygons: [],
        marker: null,
        polygonList:[],
        actives:[],
        addressMarker:null,
        isActive: true // can click
    },
    init: function(map) {
      polygonHandler.map.object = map;
      if (polygonHandler.map.object==null){
        polygonHandler.map.object = new google.maps.Map(document.getElementById(polygonHandler.config.map.domID), {
          center: polygonHandler.config.map.center,
          zoom: polygonHandler.config.map.zoom,
          styles:polygonHandler.config.map.styles
        });
      }
      polygonHandler.loader.init();
      this.data.polygonList = polygonHandler.loader.arrays;      
    },
    map: {
      methods: {
        checkIfInsidePolygon: function(lat, lng, data) {
          const location = new google.maps.LatLng(lat, lng);          
          return google.maps.geometry.poly.containsLocation(location, data.polygon);
        },
        searchInPolygons: function(lat, lng) {
          return new Promise((resolve, reject) => {
            for (let i = 0; i < polygonHandler.data.polygonList.length; i++) {
                if (this.checkIfInsidePolygon(lat, lng, polygonHandler.data.polygonList[i])) {
                    resolve(i);       
                    return;
                }
            }
            reject("Coordinates are not inside of any predefined polygon", lat, lng);
        });
        },
        searchPolygonInParallel: async function(lat, lng) {
          try {
            const result = await polygonHandler.map.methods.searchInPolygons(lat, lng);
            let polygon = polygonHandler.data.polygonList[result];
            
            polygonHandler.map.methods.togglePolygon(result);
            polygonHandler.debug.print(polygonHandler.debug.levels.INFO, `Polygon founded: ${polygon}`);
          } catch (error) {
            polygonHandler.debug.print(polygonHandler.debug.levels.ERROR, `Error on searching polygon`);
          }
        },
        togglePolygon: function(index) {
          let polygonData = polygonHandler.data.polygonList[index];
          let onNotFounded = function(index) {
            polygonData.active = true;
            polygonHandler.data.actives.push(index);
            polygonHandler.map.methods.activePolygonStyle(polygonData);            
          };

          let onFounded = function(index){
            polygonData.active = false;
            polygonHandler.data.actives.splice(index, 1);
            polygonHandler.map.methods.inactivePolygonStyle(polygonData);
          };

          polygonHandler.map.methods.handleActivePolygonByIndex(index, onFounded, onNotFounded);
        },
        handleActivePolygonByIndex: function(index, onFounded, onNotFounded) {
            var founded = false;            
            for(var i=0; i < polygonHandler.data.actives.length; i++){
              if (polygonHandler.data.actives[i]==index)
              {
                onFounded(i);
                founded = true;
                break;
              }
            }

            if(!founded){
              onNotFounded(index);
            }
            polygonHandler.loader.handleGetActivePoligons();
        },
        activePolygonStyle: function(polygonData) {
          var polygon = polygonData.polygon;
          polygonHandler.debug.print(polygonHandler.debug.levels.INFO, `Polygon: ${polygon}`);
          polygon.setOptions({ 
            strokeOpacity: 1,
            strokeColor: '#000000',
            strokeWeight:1,
            fillColor: polygonHandler.config.polygon.colorZones[parseInt(polygonData.cz)],
            fillOpacity: polygonHandler.config.polygon.fillOpacity
          });
        },
        inactivePolygonStyle: async function(polygonData) {
          var polygon = polygonData.polygon;
          polygon.setOptions({ 
            strokeWeight: polygonHandler.config.polygon.strokeWeight,
            //strokeColor: polygonHandler.config.polygon.lightStrokeColor,
            strokeColor: polygonHandler.config.polygon.colorZones[parseInt(polygonData.cz)],
            fillColor: polygonHandler.config.polygon.colorZones[parseInt(polygonData.cz)],
            fillOpacity: polygonHandler.config.polygon.transparentLightFillOpacity,
          });
        },
        highlightPolygonStyle: function(polygonData) {
          var polygon = polygonData.polygon;
          polygon.setOptions({
            fillColor: polygonHandler.config.polygon.colorZones[parseInt(polygonData.cz)],
            strokeOpacity: polygonHandler.config.polygon.strokeOpacity,
            fillOpacity: polygonHandler.config.polygon.transparentFillOpacity
          });
        },        
        addMaker: function(location, title){

          const svgMarker = {            
            path:`M213.285,0h-0.608C139.114,0,79.268,59.826,79.268,133.361c0,48.202,21.952,111.817,65.246,189.081
            c32.098,57.281,64.646,101.152,64.972,101.588c0.906,1.217,2.334,1.934,3.847,1.934c0.043,0,0.087,0,0.13-0.002
            c1.561-0.043,3.002-0.842,3.868-2.143c0.321-0.486,32.637-49.287,64.517-108.976c43.03-80.563,64.848-141.624,64.848-181.482
            C346.693,59.825,286.846,0,213.285,0z M274.865,136.62c0,34.124-27.761,61.884-61.885,61.884
            c-34.123,0-61.884-27.761-61.884-61.884s27.761-61.884,61.884-61.884C247.104,74.736,274.865,102.497,274.865,136.62z`,
            path1: "M-1.547 12l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM0 0q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
            fillColor: "black",
            fillOpacity: 0.6,
            strokeWeight: 0,
            rotation: 0,
            scale: 0.05,            
          };

          var marker = new google.maps.Marker({
            position: location,
            map: polygonHandler.map.object,
            title: title,
            icon: svgMarker
          });
          polygonHandler.data.marker = marker;
        },
        showPolygons: async function() {
          let counter = 0;
          polygonHandler.data.polygonList.forEach(function (polygonData) {
              var location = { lat: polygonData.properties.Column3, lng: polygonData.properties.Column4 };
              polygonHandler.map.methods.addPolygon(counter, polygonData);
              polygonHandler.map.methods.addMaker(location, polygonData.properties.Column1);
              counter++;            
          });          
        },
        hidePolygons: function() {
          let counter = 0;
          polygonHandler.data.polygons.forEach(function (polygonData) {
            polygonHandler.map.methods.removePolygon(counter, polygonData);
            counter++;
          });
        },
        addPolygon: async function(index, polygonData) {
          polygonHandler.debug.print(polygonHandler.debug.levels.INFO, "Polygon coordinates", index, polygonData.geometry.coordinates);
            const polygon = new google.maps.Polygon({
              paths: polygonData.geometry.coordinates,
            });
            polygonHandler.data.polygons.push({
                id: polygonData.properties.Input_FID,
                polygon: polygon,
                active: false
            });
            polygonData.polygon = polygon;
            await polygonHandler.map.methods.inactivePolygonStyle(polygonData);
            await polygonHandler.map.events.addMouseListeners(polygonData);
            await polygonHandler.map.events.addMakerListener(polygonData, index);
            await polygon.setMap(polygonHandler.map.object);
            polygonHandler.debug.print(polygonHandler.debug.levels.INFO, "Polygon added", index, polygonData.properties.Input_FID);
        },
        removePolygon: function(index, polygonData){
          let aux = [];
          if (polygonData) {
            polygonData.polygon.setMap(null);
            if (polygonHandler.data.polygons){
              try{
                polygonHandler.data.polygons.forEach(function(polygonData){
                  if (polygonData.id!=index){
                    aux.push(polygonData);
                  }
                });
              }catch(ex){ }
            }
            polygonHandler.data.polygons = aux;          
          }
        },
        getActivePolygons: function() {
          let actives = [];
          polygonHandler.data.actives.forEach(function(index){
            actives.push(polygonHandler.data.polygonList[index]);
          });
          return actives;
        },

        showAdreess(point){
          polygonHandler.map.object.setCenter(point)
          polygonHandler.map.object.setZoom(8)
          
          polygonHandler.data.addressMarker = new google.maps.Marker({ map: polygonHandler.map.object, position: point })
        },

        clearActives(){
          if(polygonHandler.data.addressMarker) polygonHandler.data.addressMarker.setMap(null)    
          polygonHandler.data.actives = []

          // polygonHandler.data.polygons.forEach(polygonData => {
          //   polygonHandler.map.methods.inactivePolygonStyle(polygonData);    
          // });

        }
      },
      events: {
        addMakerListener: async function(polygonData, index){
          google.maps.event.addListener(polygonData.polygon ? polygonData.polygon : polygonData, 'click', function(event) {
            if(polygonHandler.data.isActive == true)
              polygonHandler.map.methods.togglePolygon(index);

          });
        },
        addMouseListeners: async function(polygonData){
          var polygon = polygonData.polygon;        
          google.maps.event.addListener(polygon, 'mouseover', function () {
            if (!polygonData.active){
              polygonHandler.map.methods.highlightPolygonStyle(polygonData);
              polygonHandler.debug.print(polygonHandler.debug.levels.INFO, `Mouseover event added ${polygonData.cz}`);
            }
          });
          google.maps.event.addListener(polygon, 'mouseout', function () {
            if (!polygonData.active){
              polygonHandler.map.methods.inactivePolygonStyle(polygonData);              
            }
            polygonHandler.debug.print(polygonHandler.debug.levels.INFO, `Mouseout event added ${polygonData.cz}`);
          });
        }
      }
    },    
}